import { currency } from "@/config"

//function that will take a number as input and format it, eg 5000 would be '5k', 50000 woud be `50k` and 100000 would be `100k` and 1000000 would be `1m`
export const formatNumber = (num: number) => {
    if(num){
        if (num >= 10000000) {
            return `${(num / 10000000).toFixed(1)} Crs` || ""
        } else if (num >= 100000) {
            return `${(num / 100000).toFixed(1)}L` || ""
        } else if (num >= 1000) {
            return `${(num / 1000).toFixed(1)}T` || ""
        } else {
            return num?.toString() || ""
        }
    }
    return ""
}


//function that will take a string as input and apply a currency symbol to it, eg `5000` would be `$5000`
export const applyCurrency = (num: string) => {
    return num ? `${currency}${num}` : ""
}

export const formatFileSize = (bytes: number | string): string => {
    if (Number(bytes) === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(Number(bytes)) / Math.log(k));

    return `${parseFloat((Number(bytes) / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};

export const formatFileType = (type: string): "img" | "video" | "iframe" => {
    switch(type){
        case "image":
            return "img"
        case "video":
            return "video"
        case "document":
            return "iframe"
        default:
            return "img"
    }
}

export const getYouTubeVideoId = (url: string) => {
    if (!url) return null;

    const patterns = [
        /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)/i,
        /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([^\/\?]+)/i,
        /(?:https?:\/\/)?(?:www\.)?youtu\.be\/([^\/\?]+)/i,
        /(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([^\/\?]+)/i
    ];

    for (const pattern of patterns) {
        const match = url.match(pattern);
        if (match && match[1]) {
            return match[1];
        }
    }

    return null;
};

export const getYoutubeThumbnailUrl = (youtubeUrl: string) => {

    // Construct and return the thumbnail URL
    return `https://img.youtube.com/vi/${getYouTubeVideoId(youtubeUrl)}/hqdefault.jpg`;
}

export const getCompressedUrl = (url: string) => {
    // Construct and return the thumbnail URL
    return url.replace('/image/', '/image/compressed/');
}